import React from "react";
import {LazyLoad, LazyLoaderFactory} from "Containers/lazyRoutes";

// In the same chunk as BedeNotifications, which every logged-in page loads.
const DailyShopWheelWatcher = LazyLoaderFactory(() => import(/* webpackChunkName: "LoggedInBundledComponents" */ "Components/GambitGames/DailyShopWheel/DailyShopWheelWatcher"), () => null);
export const LazyDailyShopWheelWatcher = props => <LazyLoad isRoute={false} component={DailyShopWheelWatcher} {...props}/>;
